export const SERVICE_HISTORY_MAKES = Object.freeze([
  "AUDI",
  "BMW",
  "CUPRA",
  "FORD",
  "INFINITI",
  "JAGUAR",
  "LAND ROVER",
  "LEXUS",
  "MAZDA",
  "MERCEDES",
  "MERCEDES-BENZ",
  "MERCEDES BENZ",
  "MINI",
  "NISSAN",
  "OPEL",
  "PEUGEOT",
  "PORSCHE",
  "SEAT",
  "SKODA",
  "TOYOTA",
  "VAUXHALL",
  "VOLKSWAGEN",
]);

export function isServiceHistoryMakeAndYearEligible(make, modelYear) {
  if (!make) return false;
  const normalisedMake = make.toUpperCase().trim();
  const year = Number.parseInt(modelYear, 10);
  return SERVICE_HISTORY_MAKES.includes(normalisedMake) && Number.isInteger(year) && year >= 2012;
}
